import { useEffect, useState } from 'react';
import { IDX_BROKER_AGENT_ID } from '../constants/idx';

export const IDX_ADDONS_SCRIPT_ID = 'idxaddons-autocomplete-script';
const IDX_ADDONS_SCRIPT_SRC = 'https://idxaddons.com/addon/searchtool/RGZoOWpNRmdZMHI%3DFkDGmTYqwCn/';
const RENDER_TIMEOUT_MS = 6000;
const WIDGET_UI = 'input, form, iframe, select, button';

// Injects the IDX Addons search tool into the given container (it renders at the
// script tag's location) and reports 'loading' | 'ready' | 'failed'. The widget
// only serves on domains authorized in the IDX Addons dashboard, so a 403 or a
// silent no-render both resolve to 'failed' and the caller shows a fallback CTA.
export const useIdxAddonsScript = (containerRef) => {
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return undefined;
    const hasUi = () => Boolean(container.querySelector(WIDGET_UI));

    let script = document.getElementById(IDX_ADDONS_SCRIPT_ID);
    if (!script) {
      script = document.createElement('script');
      script.id = IDX_ADDONS_SCRIPT_ID;
      script.src = IDX_ADDONS_SCRIPT_SRC;
      script.async = true;
      script.setAttribute('data-agentid', IDX_BROKER_AGENT_ID);
      script.setAttribute('data-dropdown', 'n');
      container.appendChild(script);
    }

    const onError = () => setStatus('failed');
    script.addEventListener('error', onError);
    const poll = setInterval(() => {
      if (hasUi()) { setStatus('ready'); clearInterval(poll); }
    }, 250);
    const timer = setTimeout(() => {
      clearInterval(poll);
      setStatus(hasUi() ? 'ready' : 'failed');
    }, RENDER_TIMEOUT_MS);

    return () => {
      script.removeEventListener('error', onError);
      clearInterval(poll);
      clearTimeout(timer);
    };
  }, [containerRef]);

  return status;
};
